import { mapActions } from 'vuex'

var table = {
  data() {
    return {
      pagination: {
        descending: false,
        rowsPerPage: 10,
        sortBy: 'id',
        totalItems: 0
      },
      items: [],
      filter: {},
      timer: false
    }
  },
  watch: {
    'pagination.page' () {
      this.queue(this.load())
    },
    'pagination.descending' () {
      this.queue(this.load())
    },
    'pagination.sortBy' () {
      this.queue(this.load())
    },
    'pagination.rowsPerPage' () {
      this.queue(this.load())
    }
  },
  mounted() {
    this.queue(this.load())
  },
  methods: {
    ...mapActions(['queue']),
    loadWithDelay(delay = 400) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.background(this.load())
      }, delay)
    },
    load() {
      let params = {
        direction: this.pagination.descending ? 'desc' : 'asc',
        limit: this.pagination.rowsPerPage,
        order: this.pagination.sortBy,
        page: this.pagination.page,
        ...this.doFilter()
      }
      return this.getList(params).then((response) => {
        this.items = response.data.data ? response.data.data : response.data
        this.pagination.totalItems = response.data.total ? response.data.total : response.data.length
      })
    },
    getList(params) {
      return this.api.list(params)
    },
    clearFilter() {
      this.filter = {}
    },
    doFilter() {
      let params = {}
      Object.keys(this.filter).forEach((key) => {
        if (this.filter[key] !== null && this.filter[key] !== '') {
          params[key] = this.filter[key]
        }
      })
      return params
    },
    remove(item) {
      this.api.delete(item.id).then(response => {
        this.queue(this.load())
      })
    }
  }
}

export default table
